<template>
  <div class="block">
    <el-carousel
      :interval="interval"
      arrow="always"
      height="550px"
      @change="handleCarouselChange"
    >
      <el-carousel-item v-for="item in listActives" :key="item.id">
        <img :src="item.image" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "Slide", // Nombre del componente
  data() {
    return {
      interval: 5000, // Intervalo por defecto en milisegundos
    };
  },
  async mounted() {
    await this.getBannersActive(); // Obtiene los banners activos al cargar el componente
    this.interval = this.listActives[0].interval_ms; // Establece el intervalo del primer banner activo
  },
  computed: {
    ...mapState("appBanners", ["listActives"]), // Mapea la lista de banners activos desde el estado de Vuex a una propiedad computada
  },
  methods: {
    ...mapActions("appBanners", ["getBannersActive"]), // Mapea la acción `getBannersActive` desde Vuex a un método del componente

    /**
     * Maneja el cambio de slide en el carrusel.
     * @param {number} index - Índice del slide actual.
     */
    handleCarouselChange(index) {
      this.interval = this.listActives[index].interval_ms; // Actualiza el intervalo basado en el banner activo actual
    },
  },
};
</script>

<style>
.el-carousel__item h3 {
  color: #30445f;
  font-size: 14px;
  opacity: 0.95;
  line-height: 150px;
  margin: 0;
}
.el-carousel__container {
  width: 1100px;
  margin: auto;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
